export default __webpack_public_path__ + "static/media/home_white.d6d3eba9.svg";